import { Box, MarkerLocationIcon } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';

interface LayerThumbnailProps {
  /** Preview artwork. Falls back to a placeholder tile when absent. */
  imageUrl?: string;
}

const StyledThumbnail = styled(Box)<{ $backgroundImage: string }>`
  background-image: url(${({ $backgroundImage }) => $backgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

/**
 * The 56x56 preview tile on a base map or overlay row. Overlays have no
 * artwork yet, so they get a neutral placeholder. Decorative either way — the
 * row's title sits right beside it.
 */
const LayerThumbnail: FC<LayerThumbnailProps> = ({ imageUrl = undefined }) => {
  const size = { width: 56, height: 56, flex: '0 0 56px', borderRadius: '8px' };

  if (imageUrl) {
    return (
      <StyledThumbnail $backgroundImage={imageUrl} aria-hidden {...size} />
    );
  }

  return (
    <Box
      {...size}
      aria-hidden
      bg="lightgrey"
      display="flex"
      alignItems="center"
      justifyContent="center"
      color="darkgrey"
    >
      <MarkerLocationIcon size={22} />
    </Box>
  );
};

export default LayerThumbnail;
